import { request, ResponseProps } from "./request";
import { ALL_MENUS, MENU } from "../constants/endpoints";

export const getMenu = async () => {
  const res: ResponseProps = (await request.get(
    `${sessionStorage.getItem("gatewayURL")}${MENU}`
  )) as ResponseProps;
  if (res.success) {
    const data = res.data;
    return data;
  }
  return {};
};

export const getAllMenus = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  const r: ResponseProps = (await request.get(
    `${sessionStorage.getItem("gatewayURL")}${ALL_MENUS}`
  )) as ResponseProps;

  if (r.success) {
    const form = r.data as any;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, message: r.message };
};
